import { PopperController } from "./popper";

export class PopperTriggerBinding {
  public ariaLabel = "@?";
  public triggerTabIndex = "<?";
  public role = "@?";
}

export class PopperTriggerController {
  public popperCtrl: PopperController;
  public ariaLabel: any;
  public triggerTabIndex: number;
  public role: string;
  constructor() {}

  public togglePopper($event: ng.IAngularEvent) {
    this.popperCtrl.togglePopper();
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }
}
export const sdPopperTrigger: ng.IComponentOptions = {
  controller: PopperTriggerController,
  require: {
    popperCtrl: "^sdPopper"
  },
  transclude: true,
  template:
    '<div class="sd-popper-trigger" ng-click="$ctrl.togglePopper($event)" keyboard-activation="$ctrl.togglePopper()"  tabindex="{{$ctrl.triggerTabIndex ? $ctrl.triggerTabIndex : 0 }}" role="{{$ctrl.role}}" aria-label="{{$ctrl.ariaLabel}}" ><ng-transclude></ng-transclude></div>',
  bindings: <any>new PopperTriggerBinding()
};
